import styles from './header.module.scss';
import {
  vieLogo,
  Zaloicon,
  Tiktokicon,
  Facebookicon,
  Instaicon,
  SearchIcon,
} from '../../image';
export default function Header() {
  return (
    <div className={styles['header']}>
      <div className={styles['logo']}>
        <a href="https://viesoftware.vn">
          <img src={vieLogo} alt=""/>
        </a>
      </div>
      <div className={styles['header-right']}>
        <div className={styles['header-search']}>
          <input />
          <div className={styles['search-suffix']}>
            <SearchIcon />
          </div>
        </div>
        <div className={styles['header-social']}>
          <div className={styles['social-item']}>
            <a href="/#">
              <Zaloicon />
            </a>
          </div>
          <div className={styles['social-item']}>
            <a href="https://www.facebook.com/Viesoftware">
              <Facebookicon />
            </a>
          </div>
          <div className={styles['social-item']}>
            <a href="/#">
              <Tiktokicon />
            </a>
          </div>
          <div className={styles['social-item']}>
            <a href="/#">
              <Instaicon />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
